export default __webpack_public_path__ + "static/media/system_03_06.0efd2d94.jpg";